<template>
  <section class="product__section">
    <h2 class="product__section__heading">
      {{ $modeoL10n.product_details }}
    </h2>
    <ul class="product__section__list">
      <li
        v-if="adjustments.length > 0"
        class="product__section__list-item"
      >
        <span class="product__section__label">{{ $modeoL10n.adjustment_options }}</span>
        <ul class="product__section__adjustment-list">
          <li
            v-for="(adjustment, index) in adjustments"
            :key="index"
          >
            {{ adjustment.label }}
          </li>
        </ul>
      </li>

      <li
        v-for="(detail, index) in visibleDetails"
        :key="index"
        class="product__section__list-item"
      >
        <span class="product__section__label">{{ detail.label }}</span>
        <span class="product__section__value">{{ detail.value }}</span>
      </li>
    </ul>
    <button
      v-if="otherDetails.length > 3"
      class="product__section__show-more show-more-button"
      :class="{ 'show-more-button--close': showFullContent }"
      @click.prevent="toggle()"
    >
      {{ showFullContent ? $modeoL10n.hide : $modeoL10n.show_more }}
    </button>
  </section>
</template>

<script>
    export default {
        props: {
            adjustments: {
                type: Array,
                default: function() {
                    return [];
                },
            },
            otherDetails: {
                type: Array,
                default: function () {
                    return [];
                },
            },
        },
        data : function () {
            return {
                showFullContent: false,
            };
        },
        computed: {
            visibleDetails: function () {
                if (this.showFullContent) {
                    return this.otherDetails;
                } else {
                    return this.otherDetails.slice(0,3);
                }
            },
        },
        methods: {
            toggle : function() {
                this.showFullContent =! this.showFullContent;
            },
        },
    }
</script>
